import { UserPointsControllerApi } from '@/http/apis/UserPointsControllerApi'
const pointsApi = new UserPointsControllerApi()
export const pointService = {
  /**
   * 当前用户积分信息
   */
  async getCurrentPoints() {
    const res = await pointsApi.userPointsCurrentGet()
    return res?.data || null
  },

  /**
   * 当前用户积分历史（分页）
   */
  async getPointsHistory(params: {
    currentPage: number
    pageSize: number
    changeReason?: number
    startTime?: string
    endTime?: string
  }) {
    return await pointsApi.userPointsCurrentHistoryGet(params)
  },
   /** 获取筛选项（新增） */
  async getChangeReasons() {
    const res = await pointsApi.userPointsChangeReasonsGet()
    return res.data || []
  }
}
